export function debounce(callback: (...args: any[]) => void, waitMs: number) {
  let handle: number | undefined;
  return (...args: any[]) => {
    window.clearTimeout(handle);
    handle = window.setTimeout(() => {
      callback(...args);
    }, waitMs);
  };
}
